/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import * as actionTypes from '../constants/action-types';

export interface UNTarget {
  code: string;
  title: string;
  description: string;
}
export interface UNGoal extends UNTarget {
  targets: UNTarget[];
}

interface UNSDGMapStateData {
  goals: UNGoal[];
}

interface UNSDGMapStateCommon {
  reportType?: string,
  loaded: boolean,
  loading: boolean,
  errored: boolean,
  errorMessage?: string,
  lastUpdated?: number
}

interface UNSDGMapStateLoaded extends UNSDGMapStateCommon {
  loaded: true;
  data: UNSDGMapStateData,
}

interface UNSDGMapStateUnloaded extends UNSDGMapStateCommon {
  loaded: false;
  data: undefined;
}

export type UNSDGMapState = UNSDGMapStateLoaded | UNSDGMapStateUnloaded;

const UNSDGMap = (

  state: UNSDGMapState = {
    data: undefined,
    loading: false,
    loaded: false,
    errored: false,
    errorMessage: '',
    lastUpdated: undefined
  },

  action: {
    type: string,
    errorMessage?: string,
    data?: UNSDGMapStateData
  }

): UNSDGMapState => {

  switch (action.type) {

    case actionTypes.LOADING_UN_SDG_MAP:
      return { ...state, data: undefined, loading: true, loaded: false, errored: false, lastUpdated: Date.now() }
    case actionTypes.ERROR_UN_SDG_MAP:
      return { ...state, data: undefined, loading: false, loaded: false, errored: true, lastUpdated: Date.now(), errorMessage: action.errorMessage }
    case actionTypes.LOADED_UN_SDG_MAP:
      return { ...state, data: action.data as UNSDGMapStateData, loading: false, loaded: true, errored: false, lastUpdated: Date.now() }
    default:
      return state;

  }

}

export default UNSDGMap;
